let currentAccessToken: string | null = null

/**
 * In-memory-only bridge from the AWS SSO device-code flow's access token (held in
 * hooks/authorization/useAuthorization.ts's React state -- see useDeviceCodeFlow.ts's comment on
 * why it's never persisted to local/sessionStorage) to api/client.ts, which needs to forward it
 * to the backend as a header so the backend can independently re-derive the caller's real AWS
 * role via the AWS SSO Portal API (see backend/app/services/caller_identity_service.py). This
 * module only ever holds the token in a JS variable -- same trust level as the hook's own state,
 * never written to storage.
 */
export function setSsoAccessToken(token: string | null): void {
  currentAccessToken = token
}

export function getSsoAccessToken(): string | null {
  return currentAccessToken
}
